// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"inputCheckbox-module--wrapper--3Si4N"};